import { useLingui } from "@lingui/react";

import type { AnalysisPurchase } from "../../model/Analysis";
import { PURCHASE_PHASES } from "../../model/PURCHASE_PHASES";
import { PurchaseTile } from "./PurchaseTile";

type PurchaseTimelineProps = {
  purchases: readonly AnalysisPurchase[];
  heroId: number;
};

// Покупки по фазам матча (линия, середина, поздняя игра) в порядке покупки. Пустая фаза не показывается.
// Плитка 70 px и шаг 8 px: на телефоне в карточку шириной ~300 px встают 4 предмета в ряд.
export const PurchaseTimeline = ({ purchases, heroId }: PurchaseTimelineProps) => {
  const { _ } = useLingui();
  return PURCHASE_PHASES.map((phase) => {
    const inPhase = purchases.filter(
      (purchase) =>
        purchase.bought_at_s >= phase.fromS &&
        (phase.toS === null || purchase.bought_at_s < phase.toS),
    );
    if (inPhase.length === 0) {
      return null;
    }
    return (
      <div key={phase.id} data-phase={phase.id} className="flex flex-col gap-2">
        <h4 className="text-[13px] font-normal text-subtle">{_(phase.label)}</h4>
        <ol className="flex flex-wrap gap-x-2 gap-y-3">
          {inPhase.map((purchase) => (
            <PurchaseTile key={purchase.item_id} purchase={purchase} heroId={heroId} />
          ))}
        </ol>
      </div>
    );
  });
};
